import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  class: "CalendarsMenu posFi",
  style: {"bottom":"60px","width":"${CONTENT_WIDTH}"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "w100 roomMembersMenuTable" }
const _hoisted_6 = {
  class: "with_white_bg fl ml15 mt5",
  style: {"width":"42px","height":"42px","border-radius":"50%"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", {
  style: {"width":"160px"},
  class: "fl fw600 fs13 text-left mt12 ml5"
}, [
  /*#__PURE__*/_createTextVNode(" 自分のカレンダーから"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("予定を確認 ")
], -1)
const _hoisted_9 = {
  key: 1,
  class: "with_white_bg",
  style: {"border-radius":"18px","box-shadow":"0 18px 18px 0 rgba(10, 31, 68, 0.12), 0 0 1px 0 rgba(10, 31, 68, 0.1)"}
}
const _hoisted_10 = { class: "CalendarManagementHeader w100" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "selectCalendarPage"
}
const _hoisted_16 = {
  class: "w100",
  style: {"height":"50px","text-align":"middle","border-bottom":"1px solid #ddd"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "w100 ofs noscroll",
  style: {"height":"260px"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "w100 CalendarsMenuTable"
}
const _hoisted_21 = ["width", "onClick"]
const _hoisted_22 = {
  class: "fs12 ofh",
  style: {"padding":"5px 15px"}
}
const _hoisted_23 = {
  class: "fl skyblue fs20 mt5",
  style: {"width":"30px","height":"50px"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  class: "fl",
  style: {"width":"200px","height":"50px"}
}
const _hoisted_26 = { class: "grey fs10" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "w100 ofs",
  style: {"height":"260px"}
}
const _hoisted_30 = {
  key: 0,
  class: "w100 ofs pad10"
}
const _hoisted_31 = {
  key: 0,
  class: "posAb circleBlueButton whiteColor fw600",
  style: {"top":"0px","right":"0px","background":"#69d54f"}
}
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "調整カレンダーが見つかりませんでした。", -1)
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = {
  class: "centered w100",
  style: {"line-height":"68px","border-radius":"0 0 18px 18px","box-shadow":"4px -2px 12px #ddd"}
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 0,
  class: "fw600 fs16 ml20"
}
const _hoisted_42 = { class: "w100" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "fl ml20 fs11 fw600 mr5 mt3" }, "選択中:", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "fl ml20 fs11 fw600 mr5 mt3" }, "終日:", -1)
const _hoisted_47 = { class: "fs11" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  class: "centered",
  style: {"margin-top":"60px"}
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "予定はありません", -1)
const _hoisted_54 = ["src"]
const _hoisted_55 = {
  key: 2,
  id: `DailyContent`,
  style: {"height":"calc(100vh - 100px)"},
  class: "ofs h100 w100 noscroll"
}
const _hoisted_56 = {
  id: "timespanTitle",
  class: "timespanTitle fl",
  style: {"width":"8%"}
}
const _hoisted_57 = {
  class: "availableTimeTable w100 posRe",
  style: {"margin-left":"2%","margin-top":"0px"}
}
const _hoisted_58 = ["id"]
const _hoisted_59 = {
  class: "availableTimeTable EventsContent fl",
  style: {"width":"92%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_MessagesLoader = _resolveComponent("MessagesLoader")!
  const _component_DailyLine = _resolveComponent("DailyLine")!
  const _component_CalendarEventDetailModal = _resolveComponent("CalendarEventDetailModal")!

  return (!_ctx.isSP && _ctx.showCalendars())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          (!_ctx.openMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("table", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`posAb pointer centered with_white_bg`),
                      style: {"width":"248px","height":"52px","border-radius":"24px","top":"0","box-shadow":"0 18px 18px 0 rgba(10, 31, 68, 0.12), 0 0 1px 0 rgba(10, 31, 68, 0.1)"},
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCalendarsMenu && _ctx.openCalendarsMenu(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/add_cal.png`),
                          width: "40",
                          height: "40",
                          class: "mt3"
                        }, null, 8, _hoisted_7)
                      ]),
                      _hoisted_8
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    class: "fr mr10 mt10 pointer",
                    src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                    width: "28",
                    height: "30",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
                  }, null, 8, _hoisted_11),
                  (_ctx.pageType == `events`)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "fl ml10 mt15 pointer",
                        src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                        width: "20",
                        height: "20",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickBack && _ctx.clickBack(...args)))
                      }, null, 8, _hoisted_12))
                    : (_ctx.Util.isPresent(_ctx.pdm.check_events_info))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickDisplayEvents && _ctx.clickDisplayEvents(...args))),
                          style: {"padding":"4px 10px"},
                          class: "mt10 ml20 fw600 pointer circle_button blueAround rad8"
                        }, " 予定を表示 "))
                      : _createCommentVNode("", true),
                  _hoisted_13
                ]),
                _hoisted_14,
                (_ctx.pageType == `select`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("section", _hoisted_16, [
                        _createElementVNode("div", {
                          class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl w50 ${
                                _ctx.selectedTabName == 'astags' ? 'selected fw600' : ''
                            }`),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectCategoryTab('astags')))
                        }, " 調整カレンダー ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(`roomsCategoryTab categoryAll pointer centered fl w50 ${
                                _ctx.selectedTabName == 'ctags' ? 'selected fw600' : ''
                            }`),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectCategoryTab('ctags')))
                        }, " 外部カレンダー ", 2)
                      ]),
                      _hoisted_17,
                      _createElementVNode("div", {
                        style: _normalizeStyle({
                            width: `${_ctx.CONTENT_WIDTH}`,
                        })
                      }, [
                        (_ctx.selectedTabName == `ctags`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_TextfieldTag, {
                                placeholder: "カレンダーを検索",
                                style: _normalizeStyle(`max-width:${_ctx.CONTENT_WIDTH};height: 40px; min-width:${_ctx.CONTENT_WIDTH};`),
                                class: "lineForm fl fs14 CalendarListSearchField",
                                value: _ctx.searchText,
                                onClickTextfield: _ctx.clickSearchCalendarField,
                                onInputValue: _ctx.searchCalnedarValue,
                                onBlur: _ctx.blurSearchCalendarField
                              }, null, 8, ["style", "value", "onClickTextfield", "onInputValue", "onBlur"]),
                              _hoisted_19,
                              (_ctx.ctags)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_20, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctags, (ctag, ctagindex) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        height: "40",
                                        width: _ctx.CONTENT_WIDTH,
                                        class: _normalizeClass(`ofh pointer ${_ctx.selectedCtagEmails.includes(ctag.email) ? `selected lskyblueBg` : ``}`),
                                        onClick: ($event: any) => (_ctx.selectCtag(ctag)),
                                        key: `${ctagindex}${_ctx.selectedCtagEmails}`
                                      }, [
                                        _createElementVNode("td", _hoisted_22, [
                                          _createElementVNode("p", _hoisted_23, [
                                            (_ctx.selectedCtagEmails.includes(ctag.email))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "✔"))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("p", {
                                              class: _normalizeClass(`fs14 ${_ctx.selectedCtagEmails.includes(ctag.email) ? `fw600` : ``}`)
                                            }, _toDisplayString(ctag.name), 3),
                                            _createElementVNode("p", _hoisted_26, _toDisplayString(ctag.email), 1)
                                          ]),
                                          _hoisted_27
                                        ])
                                      ], 10, _hoisted_21))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_28
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              (_ctx.Util.isPresent(_ctx.astags))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.astags, (_astag, astagindex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: `${astagindex}${_astag.selected}${_astag.id}${_astag.type}${_astag.name}${_ctx.systemUpdatedAt}`,
                                        class: "mb10 fl posRe centered mr10"
                                      }, [
                                        _createVNode(_component_CalendarIcon, {
                                          astag: _astag,
                                          width: 120,
                                          iconWidth: 50,
                                          totalHeight: 120,
                                          onClickAstag: _ctx.selectAstag,
                                          canDelete: false,
                                          iconStyles: {
                                            marginLeft: '18%',
                                            paddingTop: '20px',
                                        }
                                        }, null, 8, ["astag", "onClickAstag"]),
                                        (_astag.selected)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                              _createElementVNode("img", {
                                                src: _ctx.$getAssetImageUrl(`/assets/icons/check_wt.png`),
                                                width: "17",
                                                height: "17",
                                                style: {"margin-top":"-2px"}
                                              }, null, 8, _hoisted_32)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _hoisted_33
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                      _hoisted_36,
                                      _createElementVNode("img", {
                                        src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                        width: "40",
                                        height: "40"
                                      }, null, 8, _hoisted_37)
                                    ])
                                  ])),
                              _hoisted_38
                            ]))
                      ], 4),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("p", {
                          class: _normalizeClass(`pointer fs14 fw600 circle_button ${_ctx.checkCanSend() ? `skyblueBg` : `lgreyBg`}`),
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirmPossibles && _ctx.confirmPossibles(...args)))
                        }, " 空いている日程を確認 ", 2)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      (_ctx.pdm.currentDate)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.pdm.currentDate) + "の予定", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultsCtags, (ctag, ctagindex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fl",
                            key: ctagindex
                          }, [
                            _createVNode(_component_UserIcon, {
                              width: 20,
                              canEdit: false,
                              member: ctag,
                              showTooltip: true,
                              class: "fl mr5 posRe"
                            }, null, 8, ["member"])
                          ]))
                        }), 128)),
                        _hoisted_44
                      ]),
                      _hoisted_45,
                      (_ctx.Util.isPresent(_ctx.alldayEvents))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "mt10",
                            style: _normalizeStyle({
                            width: `${_ctx.CONTENT_WIDTH}`,
                        })
                          }, [
                            _hoisted_46,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alldayEvents, (ev, evindex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: evindex,
                                class: _normalizeClass(`fl blackbrownBg rad4 fs11 whiteColor pad5 mb4 mr3`)
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(`whiteColor availableBox t${ev.systemUpdatedAt}`)
                                }, [
                                  _createElementVNode("span", _hoisted_47, _toDisplayString(ev.title), 1)
                                ], 2)
                              ]))
                            }), 128)),
                            _hoisted_48
                          ], 4))
                        : _createCommentVNode("", true),
                      _hoisted_49,
                      _createElementVNode("div", {
                        id: `DailyContentWrapper`,
                        class: "mt20",
                        style: _normalizeStyle({
                            width: `${_ctx.CONTENT_WIDTH}`,
                            minHeight: `200px`,
                        })
                      }, [
                        (!_ctx.displayEvents)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createVNode(_component_MessagesLoader)
                            ]))
                          : (_ctx.displayEvents.length == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _hoisted_53,
                                  _createElementVNode("img", {
                                    src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                    width: "40",
                                    height: "40"
                                  }, null, 8, _hoisted_54)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("table", _hoisted_57, [
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: `Hour${hour}${_ctx.systemUpdatedAt}`,
                                          class: _normalizeClass(``),
                                          style: _normalizeStyle({
                                                height: `${_ctx.Const.CELL_HEIGHT * 4}px`,
                                            })
                                        }, [
                                          _createElementVNode("td", {
                                            class: "posAb fw400 fs11 arial",
                                            style: {"margin-top":"-10px"},
                                            id: `timeindex${hour}`
                                          }, _toDisplayString(hour) + "時 ", 9, _hoisted_58)
                                        ], 4))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                  _createVNode(_component_DailyLine, {
                                    wday: 2,
                                    avzones: null,
                                    date: _ctx.DateTime.local(),
                                    id: `${_ctx.pdm.currentDateId}`,
                                    didConnectCal: true,
                                    checkConflictEvents: _ctx.displayEvents,
                                    type: `top`,
                                    onShowEventDetail: _ctx.showEventDetail
                                  }, null, 8, ["date", "id", "checkConflictEvents", "onShowEventDetail"])
                                ])
                              ]))
                      ], 4)
                    ]))
              ]))
        ]),
        _createVNode(_component_CalendarEventDetailModal)
      ]))
    : _createCommentVNode("", true)
}